import { create } from "zustand";

interface CommonState {
  isSidebarOpen: boolean;
  isOpenSort: boolean;
  reload: boolean;
  reloadInfo: boolean;
  setIsSidebarOpen: (isSidebarOpen: boolean) => void;
  setOpenSort: (isOpenSort: boolean) => void;
  setReload: (reload: boolean) => void;
  setReloadInfo: (reloadInfo: boolean) => void;
}

export const useCommonStore = create<CommonState>((set) => ({
  isSidebarOpen: true,
  isOpenSort: false,
  reload: false,
  reloadInfo: false,
  setIsSidebarOpen: (isSidebarOpen: boolean) => set(() => ({ isSidebarOpen })),
  setOpenSort: (isOpenSort: boolean) => set(() => ({ isOpenSort })),
  setReload: (reload: boolean) => set(() => ({ reload })),
  setReloadInfo: (reloadInfo: boolean) => set(() => ({ reloadInfo })),
}));
